module.exports = "<h1>Payment-Failure</h1>"


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/payment-failure/payment-failure.component.html
// module id = ./src/app/registration/payment-failure/payment-failure.component.html
// module chunks = main